<template>
  <apexchart
    type='line'
    ref="apexchart"
    :options='apexchart.options'
    :series='apexchart.series'
  ></apexchart>
</template>
<script>
/**
 * @file DDv2用グラフ表示コンポーネント
 */
import flowMixin from '@/mixins/flowMixins'
import VueApexCharts from 'vue-apexcharts'
import filter from '@/rahmen/utils/filters'

export default {
  name: 'DdChartLineBar',
  mixins: [flowMixin],
  props: {
    /**
     * タイトル
     */
    titleText: {
      type: String,
      default: ''
    },
    /**
     * 高さ
     */
    chartHeight: {
      type: String,
      default: '400'
    },
    /**
     * メニューバー表示制御
     */
    showToolbar: {
      type: Boolean,
      default: false
    },
    /**
     * zoom機能使用制御
     */
    zoomEnabled: {
      type: Boolean,
      default: false
    },
    /**
     * 棒グラフの色を棒ごとに変更するか
     */
    distributedColor: {
      type: Boolean,
      default: false
    },
    /**
     * 凡例表示制御
     */
    showLegend: {
      type: Boolean,
      default: true
    },
    /**
     * データフォーマット指定
     * num → 数値を３桁で区切る
     * 未指定時は何もしない。
     */
    labelFormatType: {
      type: String,
      default: ''
    }
  },
  components: {
    apexchart: VueApexCharts
  },
  data: () => ({
    apexchart: {
      defaultLocale: 'ja',
      locales: {
        name: 'ja',
        options: {
          months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
          days: ['日', '月', '火', '水', '木', '金', '土'],
          toolbar: {
            exportToSVG: 'SVGダウンロード',
            exportToPNG: 'PNGダウンロード',
            exportToCSV: 'CSVダウンロード',
            menu: 'メニュー',
            selection: '選択',
            selectionZoom: '選択ズーム',
            zoomIn: '拡大',
            zoomOut: '縮小',
            pan: 'パン',
            reset: 'ズームリセット'
          }
        }
      },
      options: {
        xaxis: {
          type: 'category',
          labels: {
            style: {
              cssClass: 'text-black-bold'
            }
          }
        },
        yaxis: {
          labels: {
            style: {
              cssClass: 'text-black-bold'
            }
          }
        },
        legend: {
          horizontalAlign: 'left',
          fontSize: '20px',
          fontWeight: 500,
          fontFamily: 'YuGothic'
        },
        noData: {
          text: '対象のデータがありません。',
          style: {
            fontSize: '20px',
            fontFamily: 'YuGothic'
          }
        }
      },
      series: []
    }
  }),
  created () {
  },
  mounted () {
    const self = this
    console.log(self.dataSource)
    self.$refs.apexchart.updateOptions({
      chart: {
        height: self.chartHeight,
        zoom: {
          enabled: self.zoomEnabled
        },
        toolbar: {
          show: self.showToolbar
        }
      },
      plotOptions: {
        bar: {
          distributed: self.distributedColor
        }
      },
      title: {
        text: self.titleText
      },
      yaxis: {
        labels: {
          formatter: function (value) {
            // フォーマット指定パターンが増えたら随時追加
            if (self.labelFormatType === 'num') {
              return filter.numericFormatter(value)
            } else {
              return value
            }
          }
        }
      },
      legend: {
        show: self.showLegend
      }
    })
  },
  computed: {
  },
  methods: {
    updateDispData: function (dataSource) {
      const self = this
      // グラフ用データを変えて、再描画を行う。
      self.$refs.apexchart.updateSeries(dataSource, true)
    }
  }
}
</script>
<style scoped>
</style>
